<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
// import appMian  from './view/index/appMian.vue';
export default {
  name: 'App',
  components: {
    // appMian
  },
  data(){
    return{
  
    }
  }
}
</script>

<style>
#app {
  font-family: Oxanium, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #161619;
  background: #191919;
}

* {
  margin: 0;
  padding: 0;
}
</style>
